import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { ErrorToast } from "../../../../Utils/SweetAlert";
import { useQuery } from "@tanstack/react-query";
import Tooltip from "@mui/material/Tooltip";
import { GetSingleGuide } from "../../../../Api/guide";
import BackButton from "../../../../Components/BackButton";

const GuideDetail = () => {
  const stateData = useLocation();
  const { id } = stateData?.state || "";

  /**
   * Get guide product single record
   */
  const { data } = useQuery({
    queryKey: ["get-single-guide"],
    queryFn: () => GetSingleGuide({ id: id }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  return (
    <>
      <Helmet>
        <title>OVE | Admin Guide Product Detail</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Guide Product Detail</h3>
                      </div>
                      <div className="col-auto">
                        <BackButton to="/admin/guide-listing" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <span className="d-block modal-value-guide">
                        {data?.data?.name || "-"}
                      </span>
                    </div>
                    <div>
                      {data?.data?.imageUrl ? (
                        <img
                          src={data?.data?.imageUrl}
                          alt={data?.data?.image}
                          height={124}
                          width={208}
                          className="guide-detail-image"
                          onError={(e) => {
                            e.currentTarget.src = "/images/defaultImage.jpg"; // fallback image path
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </div>
                    <div>
                      <div className="d-block modal-value mt-3">
                        {data?.data?.details?.description || "-"}
                      </div>
                    </div>
                    <div className="row">
                      {data?.data?.details?.images?.map(
                        (imageData, imageIndex) => (
                          <div className="col-auto" key={imageIndex}>
                            {imageData ? (
                              <img
                                src={imageData}
                                alt={imageData}
                                width={210}
                                height={124}
                                className="guide-detail-image"
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        )
                      )}
                    </div>

                    {data?.data?.details?.howToUse.length > 0 && (
                      <div>
                        <h4 className="mt-3">How To Use?</h4>
                        <div className="row">
                          {data?.data?.details?.howToUse?.map(
                            (detail, index) => (
                              <div
                                className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3"
                                key={index}
                              >
                                <div className="how-to-use-card">
                                  {/* Image section */}
                                  {detail?.images?.map(
                                    (imageData, imageIndex) => (
                                      <div key={imageIndex}>
                                        {imageData ? (
                                          <img
                                            src={imageData}
                                            alt={`How to use image ${imageIndex}`}
                                            className="guide-detail-use-image"
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    )
                                  )}

                                  {/* Description section */}
                                  <div className="how-to-use-description mt-2">
                                    <Tooltip
                                      title={detail?.description}
                                      placement="top"
                                    >
                                      <span>
                                        {detail?.description?.length >= 40
                                          ? detail?.description.substring(
                                            0,
                                            45
                                          ) + "..."
                                          : detail?.description || "-"}
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {data?.data?.details?.howToRemove?.length > 0 && (
                      <div>
                        <h4 className="mt-3">How To Remove?</h4>
                        <div className="section-border">
                          {data?.data?.details?.howToRemove?.map(
                            (detail, index) => (
                              <div className="row" key={index}>
                                <div className="col-md-6 des-line">
                                  <li className="">
                                    {detail?.description || "-"}
                                  </li>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {data?.data?.details?.howToClean?.length > 0 && (
                      <div >
                        <h4 className="mt-3">How To Clean?</h4>
                        <div className="section-border">
                          {data?.data?.details?.howToClean?.map(
                            (detail, index) => (
                              <div className="row" key={index}>
                                <div className="col-md-6 des-line">
                                  <li className="">
                                    {detail?.description || "-"}
                                  </li>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {data?.data?.details?.howToChange?.length > 0 && (
                      <div >
                        <h4 className="mt-3">How To Change?</h4>
                        <div className="section-border">
                          {data?.data?.details?.howToChange?.map(
                            (detail, index) => (
                              <div className="row" key={index}>
                                <div className="col-md-6  des-line">
                                  <li className="">
                                    {detail?.description || "-"}
                                  </li>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideDetail;
